'use client';

import { Button } from '@spikemark/ui/components/ui/button';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { FC, PropsWithChildren, useState } from 'react';
import { ExpandableComponentContainer } from '@spikemark/ui/components/expandable-content-container';
export const ScorecardExpander: FC<PropsWithChildren> = ({
  children
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  return <>
      <ExpandableComponentContainer expanded={isExpanded} data-sentry-element="ExpandableComponentContainer" data-sentry-source-file="scorecard-expander.tsx">{children}</ExpandableComponentContainer>
      <div className="text-center lg:py-1 border-t border-gray-200">
        <Button variant="ghost" size="sm" onClick={prev => setIsExpanded(!isExpanded)} data-sentry-element="Button" data-sentry-source-file="scorecard-expander.tsx">
          {isExpanded ? <>
              Hide details
              <ChevronUp className="ml-1" size={18} />
            </> : <>
              Show details
              <ChevronDown className="ml-1" size={18} />
            </>}
        </Button>
      </div>
    </>;
};